import { AccountInfo } from '@azure/msal-browser';
import { AxiosRequestConfig } from 'axios';
import environment from '../../config/env';
import { UserRole } from '../../interface/user';
import { AuthorizedService } from '../../service/authorized.service';

class AuthService extends AuthorizedService {
  private accessToken?: string | null;
  private idToken?: string | null;
  private config?: AxiosRequestConfig | null;
  private role?: UserRole | null;
  private user?: AccountInfo | null;

  get requestConfig(): AxiosRequestConfig | undefined | null {
    return this.config;
  }

  set msalAuthState(
    authState:
      | { isAuthenticated: boolean; account: AccountInfo | null; accessToken?: string; idToken?: string }
      | undefined
      | null,
  ) {
    if (authState?.isAuthenticated && authState.account) {
      this.accessToken = authState.accessToken;
      this.idToken = authState.idToken;
      this.config = {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
        },
      };
      this.user = authState.account;
    } else {
      this.accessToken = null;
      this.idToken = null;
      this.config = {};
      this.role = null;
      this.user = null;
      this.clearSession();
    }
  }

  public getLoggedUser(): Promise<AccountInfo | null> {
    if (this.user) {
      return Promise.resolve(this.user);
    }

    const storedUser = this.getStoredSession();
    if (storedUser) {
      this.user = storedUser;
      return Promise.resolve(storedUser);
    }

    return Promise.resolve(null);
  }

  public storeUser(nativeId?: string, email?: string, fullName?: string): Promise<void> {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: this.config?.headers?.Authorization as string,
        id_token: this.idToken as string,
      },
    };
    return super.post('user/storeUser', config, { params: { nativeId, email, fullName } });
  }

  private getStoredSession(): AccountInfo | undefined | null {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  private storeSession(user?: AccountInfo | null): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  private clearSession(): void {
    localStorage.removeItem('user');
  }
}

const authService = new AuthService(environment.ADMIN_API_URL);
export default authService;
